module.exports = __webpack_public_path__ + "img/course-cover05.789bfd11.jpg";